import { makeAutoObservable } from 'mobx';

class CalendarState {
  agent;

  startDate = new Date().toISOString();
  endDate = new Date().toISOString();

  events = [];
  isLoading = false;
  selectedEvent = {};

  constructor() {
    makeAutoObservable(this, {
      agent: false
    });
  }

  setInteractiveAgent(agent) {
    this.agent = agent;
  }

  async updateDates(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export default CalendarState;
